import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import 'hammerjs';

import { environment } from './environments/environment';
import { OnboardingModule } from './onboarding/onboarding.module';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(OnboardingModule)
  .catch(err => console.error(err));
